var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-sortable",
        {
          attrs: {
            tag: "w-list",
            items: _vm.sortedList,
            "disable-x": "",
            "keep-in-y": "",
            "target-class": "handle",
          },
          on: {
            drop: function ($event) {
              return _vm.saveOrder()
            },
          },
        },
        [
          _vm._l(_vm.sortedList, function (layout) {
            return _c(
              "w-list-item",
              { key: layout.ID, attrs: { "show-handle": "" } },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(layout.Name))]),
                _c("w-list-item-action"),
                _vm.isElectron
                  ? _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("set-default-printer"),
                                expression: "$ct('set-default-printer')",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.editElectronProperties(layout)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "print" } })],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.edit-conditions"),
                            expression: "$ct('common.edit-conditions')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editConditions(layout)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "filter" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _vm.canCreateLayout
                      ? _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("common.copy"),
                                expression: "$ct('common.copy')",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.copyLayout(layout)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "copy" } })],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.edit"),
                            expression: "$ct('common.edit')",
                          },
                        ],
                        attrs: { to: "/settings/sale-layout/" + layout.ID },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _vm.canDeleteLayouts
                      ? _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("common.delete"),
                                expression: "$ct('common.delete')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.deleleLayout(layout)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm.canCreateLayout
            ? _c(
                "w-list-item",
                { attrs: { to: _vm.createLink } },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(" " + _vm._s(_vm.$ct("create-sale-layout")) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.editElectronPropertiesLayoutId != 0 } },
        [
          _vm.editElectronPropertiesLayoutId
            ? _c("app-sale-layout-edit-electron-properties", {
                attrs: {
                  printers: _vm.printers,
                  "layout-id": _vm.editElectronPropertiesLayoutId,
                },
                on: {
                  close: function ($event) {
                    _vm.editElectronPropertiesLayoutId = 0
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.toEditConditionsLayout
        ? _c("app-sale-layout-conditions-edit-modal", {
            attrs: { layout: _vm.toEditConditionsLayout },
            on: {
              close: function ($event) {
                _vm.toEditConditionsLayout = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }